import { Route } from "@angular/router";
import { SubscriptionTypeEnum } from "../organisation/models/subscription";

export const FormsPaths = {
  PersonFormOverview: "persoon/overzicht",
  PersonFormAdd: "persoon/toevoegen",
  GeneralFormOverview: "overzicht",
  SubmissionAdd: (formId: number | string, formKey: number | string) =>
    `${formId}/indienen/${formKey}`,
  SubmissionEdit: (
    formId: number | string,
    formKey: number | string,
    documentId: number | string
  ) => `${formId}/indienen/${formKey}/${documentId}`,
  PersonEdit: (formId: number | string) => `persoon/bewerken/${formId}`,
  ReportEdit: (formId: number | string) => `bewerken/${formId}/rapport`,
  FormDocumentList: (formId: number | string) => `${formId}/dossiers`,
};

export default [
  {
    path: "",
    loadComponent: () =>
      import("./pages/form-list/form-list.component").then((c) => c.FormListComponent),
    data: {
      breadcrumb: "Formulieren",
      title: "Formulieren beheren",
      subscriptionTypes: [1],
    },
  },
  {
    path: FormsPaths.PersonFormOverview,
    loadComponent: () =>
      import("./pages/form-list/form-list.component").then((c) => c.FormListComponent),
    data: {
      breadcrumb: "Overzicht",
      title: "Formulieren beheren",
      subscriptionTypes: [1],
    },
  },
  {
    path: "formulieren/overzicht",
    redirectTo: FormsPaths.PersonFormOverview,
    pathMatch: "full",
  },
  {
    path: FormsPaths.PersonFormAdd,
    loadComponent: () =>
      import("./pages/form-edit/form-edit.component").then((c) => c.FormEditComponent),
    data: {
      breadcrumb: "Formulier toevoegen",
      title: "Formulier toevoegen",
      subscriptionTypes: [1],
    },
  },
  {
    path: FormsPaths.PersonEdit(":id"),
    loadComponent: () =>
      import("./pages/form-edit/form-edit.component").then((c) => c.FormEditComponent),
    data: {
      breadcrumb: "Formulier bewerken",
      title: "Formulier bewerken",
      subscriptionTypes: [1],
    },
  },
  {
    path: FormsPaths.SubmissionAdd(":formId", ":formKey"),
    loadComponent: () =>
      import("./pages/form-submission/form-submission.component").then(
        (c) => c.FormSubmissionComponent
      ),
    data: {
      breadcrumb: "Formulier indienen",
      title: " ",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: FormsPaths.SubmissionEdit(":formId", ":formKey", ":documentId"),
    loadComponent: () =>
      import("./pages/form-submission/form-submission.component").then(
        (c) => c.FormSubmissionComponent
      ),
    data: {
      breadcrumb: "Formulier indienen",
      title: " ",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: FormsPaths.ReportEdit(":id"),
    loadComponent: () =>
      import("./pages/form-report-edit/form-report-edit.component").then(
        (c) => c.FormReportEditComponent
      ),
    data: {
      breadcrumb: "Rapport bewerken",
      title: "Rapport bewerken",
      subscriptionTypes: [1],
    },
  },
  {
    path: FormsPaths.FormDocumentList(":id"),
    loadComponent: () =>
      import("./pages/form-document-list/form-document-list.component").then(
        (c) => c.FormDocumentListComponent
      ),
    data: {
      breadcrumb: "Dossiers",
      title: "Dossiers",
      subscriptionTypes: [1],
    },
  },
  {
    path: FormsPaths.GeneralFormOverview,
    loadComponent: () =>
      import("../menu/pages/on-hold/on-hold.component").then((c) => c.OnHoldComponent),
    data: {
      breadcrumb: "Formulieren",
      title: "Formulieren",
      subscriptionTypes: [SubscriptionTypeEnum.Plus],
      previousVersionUrl: "https://app.assistonline.eu/dba/#/app/vereniging/formulieren",
    },
  },
] satisfies Route[];
